<template>
    <div>
        <div class="container">
            <div class="row justify-content-md-center align-items-center" id="merci">
                <div class="col col-lg-5 col-12">
                    <p class="note">
                        Très bien {{d_civilite}} {{d_nom}}, je vous contacterai dans les 48h (jour ouvré) afin de définir ensemble le jour et l'heure qui vous conviendra. 
                    </p>
                    <p class="note">
                        Pour information lorsque je vous appelerai le numéro de téléphone qui s'affichera sera le 03.89.41.04.16.
                    </p>
                </div>
                <div class="col col-lg-5 col-12">
                    <span class="circle">3</span>
                    <div class='card panel_form'>
                        <div class="card-body text-center">
                            <p>En attendant, pour préparer notre entretien, je vous encourage à visiter notre site internet.</p>
                            <a href="https://www.rivalis-recrutement.fr" id="gotosite">Aller sur le site</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ["email", "telephone", "nom", "civilite"],
        mounted () {
            this.d_email =this.email
            this.d_telephone =this.telephone
            this.d_nom =this.nom
            this.d_civilite =this.civilite
            this.d_date =this.date
        },
        data () {
            return {
                d_email: false,
                d_telephone: false,
                d_nom: false,
                d_civilite: false,
                d_date: false
            }
        }
    }
</script>

<style lang="less" scoped>
div#merci {
    margin-top:70px;
    p{
        font-size:22px;
    }
    p.note {
        color: #167bc1;
    }
}

div.panel_form {
    box-shadow: 0 0 5px 5px rgba(0,0,0,0.1);
    border-radius: 20px;
    p {
        margin-bottom:40px;
    }
    a#gotosite {
        color: white;
        background: #c9d100;
        padding:15px 20px;
        font-size:22px;
    }
}

span.circle {
    background: #167bc1;
    border-radius: 50%;
    padding: 30px 40px;
    text-align: center;
    color: white;
    font-size: 30px;
    margin-left:39%;
}

</style>